import { render, staticRenderFns } from "./Prakerja.vue?vue&type=template&id=af4ea40c"
import script from "./Prakerja.vue?vue&type=script&lang=js"
export * from "./Prakerja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports